/**
 * Breakpoints related to the SCSS breakpoints variables in the variables.scss
 */
export const BREAKPOINTS = {
    desktopLarge: 1680,
    desktopMedium: 1440,
    desktop: 1280,
    tabletLandscape: 992,
    tablet: 768,
    mobileLandscape: 480,
    maxMobile: 320,
    iphone: 360,
    maxDesktopMedium: 1679,
    maxDesktop: 1439,
    maxTabletLandscape: 1279,
    maxTablet: 991,
    maxMobileLandscape: 479,
};